// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1033f0ad]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.site-divider[data-v-1033f0ad]{padding:20px 0 0}.site-divider[data-v-1033f0ad]:after{background-color:hsla(0,0%,100%,.1);content:\"\";height:1px;left:0;position:absolute;width:100%}.m-default[data-v-1033f0ad]{margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
